<!-- Do not change this file. -->

<template>
  <div class="bg-light h-100 d-flex flex-column">
    <div class="showAboveFullScreenComponents" v-if="browser !== 'Chrome'">
      You are using {{ browser }} and the suggested Browser is Chrome.
    </div>

    <div :class="{ 'mb-3': !isGame }">
      <TheHeader />
      <TheNavbar v-if="!isGame" />
    </div>
    <div class="flex-grow-1 bg-light" :class="{ 'pb-3': !isGame }">
      <router-view />
    </div>
    <TheFooter />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader";
import TheFooter from "@/components/core/TheFooter";
import TheNavbar from "@/components/core/TheNavbar";

// API for performing CRUD operations from the Datastore
import DatastoreAPI from "@/helpers/DatastoreAPI";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  mixins: [DatastoreAPI],
  components: {
    TheHeader,
    TheNavbar,
    TheFooter
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("datastore", ["entry", "entryLoaded"]),
    ...mapGetters(["mapToDatastore"]),
    isGame() {
      return this.$route.name === "Game";
    },
    browser() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
      const userAgent = navigator.userAgent;
      let browserName = "Unknown";

      if (/chrome/i.test(userAgent) && !/edge|opr\//i.test(userAgent)) {
        browserName = "Chrome";
      } else if (
        /safari/i.test(userAgent) &&
        !/chrome|opr\//i.test(userAgent)
      ) {
        browserName = "Safari";
      } else if (/firefox/i.test(userAgent)) {
        browserName = "Firefox";
      } else if (/edg/i.test(userAgent)) {
        browserName = "Edge";
      } else if (/opr\//i.test(userAgent)) {
        browserName = "Opera";
      } else if (/msie|trident/i.test(userAgent)) {
        browserName = "Internet Explorer";
      }

      return browserName;
    }
  },
  methods: {
    ...mapActions(["mapFromDatastore"])
  },
  watch: {
    /* Each time the route changes, read from the datastore */
    $route: "readEntry",
    entry() {
      /* When Vuex datastore/entry updates,
      map to Vuex App State */
      this.mapFromDatastore(this.entry);
    },
    entryLoaded() {
      /* When Vuex datastore/entryLoaded updates,
      here is an opportunity to initial */
      if (this.entry === "") {
        // call vuex actions to set your initial state, then call....
        // this.setSomething(value);
        this.updateEntry(this.mapToDatastore);
      }
    }
  },
  created() {}
};
</script>
